import { testimonials } from "@/mocks/gua";

export default function Praise() {
  return (
    <section id="praise" className="relative overflow-hidden bg-primary-950">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col items-center text-center">
          <span className="mb-3 inline-flex items-center gap-2 rounded-full border border-primary-700 bg-primary-900 px-3 py-1 text-xs font-medium text-primary-200">
            <i className="ri-heart-3-line"></i>瓜友口碑
          </span>
          <h2 className="font-heading text-2xl font-black text-background-50 md:text-4xl">
            大家一起，把瓜吃得更明白
          </h2>
          <p className="mt-3 max-w-xl text-sm text-background-300 md:text-base">
            无论是追剧追综艺的休闲用户，还是需要抓热点的从业者，都能在这里找到自己的吃法。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((t) => (
            <figure
              key={t.name}
              className="flex flex-col rounded-xl border border-primary-800 bg-primary-900/60 p-6"
            >
              <i className="ri-double-quotes-l text-2xl text-accent-400"></i>
              <blockquote className="mt-3 flex-1 text-sm leading-7 text-background-200">
                {t.text}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-primary-800 pt-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-800 text-accent-300">
                  <i className={`${t.icon} text-lg`}></i>
                </span>
                <div>
                  <div className="text-sm font-medium text-background-50">{t.name}</div>
                  <div className="text-xs text-background-400">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}